module.exports = __webpack_public_path__ + "style/img/RE_icon_Product.992c1b36.png";